import React from 'react';
import Svg, { Path } from 'react-native-svg';

const StarIconOutlined = ({ fill }: { fill?: string }) => {
  return (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <Path
        d="M8.00016 10.2626L5.4935 11.7759L6.1535 8.9226L3.94016 7.0026L6.86016 6.75594L8.00016 4.0626L9.14016 6.75594L12.0602 7.0026L9.84683 8.9226L10.5068 11.7759M14.6668 6.1626L9.8735 5.75594L8.00016 1.33594L6.12683 5.75594L1.3335 6.1626L4.96683 9.31594L3.88016 14.0026L8.00016 11.5159L12.1202 14.0026L11.0268 9.31594L14.6668 6.1626Z"
        fill={fill || '#ADB6B9'}
      />
    </Svg>
  );
};

export default StarIconOutlined;
